import { ErrorOutlineOutlined } from '@mui/icons-material'
import Immutable from 'immutable'
import styles from './FormError.module.scss'

export default function FormError ({ errorsList = Immutable.fromJS({}) }) {

  if (!errorsList.size) {
    return
  }

  return (
    <div className={styles.formErrorWrapper}>
      {errorsList.valueSeq().map((errorGroup, groupIndex) => {
        return (
          errorGroup.map((error, errorIndex) => {
            return (
              <div key={`error-${groupIndex}-${errorIndex}`} className={styles.singleError}>
                <ErrorOutlineOutlined color={error} />
                <span>{error}</span>
              </div>
            )
          })
        )
      })}
    </div>
  )
}